{
  "account": {
    "fields": {
      "userId": "Nutzer-ID",
      "webId": "Web-ID",
      "userRole": "Benutzerrolle",
      "accountType": "Kontotyp"
    },
    "sections": {
      "security": "Sicherheit"
    },
    "buttons": {
      "addPassword": "Passwort anlegen",
      "refresh": "Neu laden",
      "logout": "Abmelden"
    },
    "messages": {
      "passwordEnabled": "Passwort-Authentifizierung ist für dein Konto aktiviert.",
      "addPasswordPrompt": "Füge ein Passwort hinzu, um neben deiner SSO-Methode auch die Anmeldung mit Passwort zu ermöglichen."
    },
    "accountTypes": {
      "admin": "Admin",
      "fboUser": "FBO-Benutzer"
    },
    "addPasswordDialog": {
      "title": "Passwort-Authentifizierung hinzufügen",
      "successMessage": "Passwort erfolgreich hinzugefügt! Du kannst dich jetzt mit deiner E-Mail-Adresse und deinem Passwort anmelden.",
      "description": "Füge ein Passwort zu deinem Konto ({{userEmail}}) hinzu, um neben deiner bestehenden SSO-Methode auch die Anmeldung mit Passwort zu ermöglichen.",
      "labels": {
        "newPassword": "Neues Passwort",
        "confirmPassword": "Passwort bestätigen",
        "strength": "Stärke: {{strength}}"
      },
      "validationErrors": {
        "tooShort": "Passwort muss mindestens 8 Zeichen haben",
        "needsUppercase": "Passwort muss mindestens einen Großbuchstaben enthalten",
        "needsLowercase": "Passwort muss mindestens einen Kleinbuchstaben enthalten",
        "needsNumber": "Passwort muss mindestens eine Zahl enthalten",
        "noMatch": "Passwörter stimmen nicht überein",
        "setFailed": "Passwort setzen fehlgeschlagen",
        "genericError": "Fehler aufgetreten"
      },
      "strength": {
        "tooShort": "Zu kurz",
        "weak": "Schwach",
        "fair": "Okay",
        "good": "Gut",
        "strong": "Stark"
      },
      "requirements": "Mindestens 8 Zeichen mit Groß-, Kleinbuchstaben und Zahlen",
      "buttons": {
        "cancel": "Abbrechen",
        "adding": "Hinzufügen...",
        "addPassword": "Passwort anlegen",
        "close": "Schließen"
      }
    },
    "roleSwitcher": {
      "title": "Rollentest (nur Admin)",
      "description": "Teste die Anwendung als verschiedene Benutzerrollen, um Berechtigungen und UI-Verhalten zu überprüfen. Dies ist nur eine clientseitige Überschreibung, die die Datenbank nicht beeinflusst.",
      "selectLabel": "Als Rolle testen",
      "activeMessage": "Rollentest ist aktiv. Nutze den schwebenden Button (unten rechts), um Rollen zu wechseln oder zu beenden.",
      "buttonStartTesting": "Als {{role}} testen"
    },
    "languageSwitcher": {
      "title": "Sprachtest (nur Admin)",
      "description": "Aktiviere einen schwebenden Button für schnellen Sprachwechsel, um Übersetzungen zu testen.",
      "buttonEnable": "Sprachumschalter aktivieren",
      "buttonDisable": "Sprachumschalter deaktivieren",
      "activeMessage": "Sprachtest ist aktiv. Nutze den schwebenden Button (unten rechts), um die Sprache zu wechseln."
    }
  },
  "configuration": {
    "sections": {
      "personalPreferences": "Persönliche Einstellungen",
      "globalPermissions": "Globale Berechtigungen",
      "rolePermissions": "Rollenberechtigungen",
      "emailIngestion": "E-Mail-Eingangsadresse"
    },
    "descriptions": {
      "personalPreferences": "Passe deine persönlichen Anzeige- und Verhaltenseinstellungen an.",
      "globalPermissions": "Globale Berechtigungen umschalten. Diese gelten für alle Benutzer, unabhängig von ihrer Rolle.",
      "rolePermissions": "Berechtigungen für jede Benutzerrolle ein- oder ausschalten. Diese Berechtigungen werden auf alle Benutzer der jeweiligen Rolle angewendet.",
      "emailIngestion": "Leite Flugpläne und Reservierungen an diese E-Mail-Adresse für automatischen Import weiter."
    },
    "emailIngestion": {
      "copied": "E-Mail-Adresse kopiert",
      "copyTooltip": "Kopieren"
    },
    "personalPreferences": {
      "darkMode": "Dunkelmodus",
      "hideLockReminder": "Gesperrte Flugzeuge ausblenden",
      "showAircraftLabels": "Flugzeug-Labels anzeigen",
      "language": "Sprache"
    },
    "globalPermissions": {
      "excludeObstructions": "Hindernisse und No-Tow ausschließen",
      "forceDisplayNotes": "Notizen in Ansichtseinstellungen",
      "enableScheduling": "Planungsfunktionen aktivieren",
      "displayDetailedDecisionLog": "Entscheidungsdetails anzeigen",
      "airportCode": "Flughafencode",
      "useListHoldingArea": "Listen-Wartebereich nutzen",
      "enableAutoParking": "AutoPark aktivieren",
      "enableOpsCenter": "Ops Center aktivieren",
      "useMetricSystem": "Metrisch verwenden",
      "timezone": "Zeitzone"
    },
    "tooltips": {
      "excludeObstructions": "Standardmäßig verwendet AirPlx die Hangarbreite und -tiefe als Gesamtfläche für die Auslastungsberechnung. Du kannst bei Bedarf Hindernisse (Büros, Käfige usw.) und Sicherheitsbereiche (Schleppverbotszonen) ausschließen.",
      "enableScheduling": "Zeigt die Flugplanungsfunktionen einschließlich Zeitplanseiten und Zeitleistenansichten an. Wenn deaktiviert, werden die Planungsfunktionen in der Benutzeroberfläche ausgeblendet.",
      "displayDetailedDecisionLog": "Detaillierte Statistiken, Entscheidungsprotokoll-Tab und Leistungsmetriken im AutoPark-Ergebnisdialog anzeigen. Für Entwicklungs- und Debugging-Zwecke.",
      "airportCode": "ICAO- oder IATA-Flughafencode für dieses FBO (z. B. KBZN, KJFK). Wird für FlightAware-Flugverfolgung im Ops Center verwendet.",
      "useListHoldingArea": "Wenn aktiviert, wird der moderne listenbasierte Wartebereich verwendet. Wenn deaktiviert, wird der visuelle Canvas-basierte Wartebereich verwendet.",
      "enableAutoParking": "Wenn aktiviert, werden Auto-Parking-Funktionen verfügbar. Hinweis: Sowohl diese Einstellung ALS AUCH der AutoParking-Schalter des jeweiligen Ramps (im Ramp-Editor) müssen aktiviert sein, um Auto-Parking-Funktionen zu nutzen.",
      "enableOpsCenter": "Ops Center in der Navigation für Systemadministratoren anzeigen. Das Ops Center bietet Echtzeit-Flugverfolgung, Ankunfts-/Abflugüberwachung und CSR-Workflow-Tools. Wenn deaktiviert, wird das Ops Center im Navigationsmenü ausgeblendet.",
      "timezone": "IANA-Zeitzone für diesen FBO-Standort. Wird für die Umrechnung lokaler Zeiten bei der E-Mail-Verarbeitung verwendet (z. B. wenn FBO One Ankunftszeiten in Ortszeit sendet)."
    },
    "permissions": {
      "displayEstimatedValue": {
        "label": "Geschätzten Wert anzeigen",
        "description": "Geschätzten Wert im Dashboard anzeigen."
      },
      "addTeamMembers": {
        "label": "Team hinzufügen",
        "description": "Füge Teammitglieder zum FBO hinzu."
      },
      "modifyTenants": {
        "label": "Mandanten bearbeiten",
        "description": "Verwalte Flugzeugregistrierungen und Mieterinformationen."
      },
      "modifyLayout": {
        "label": "Layout anpassen",
        "description": "Layoutelemente bearbeiten (Spots, Zonen, Hindernisse, Referenzbilder, Kalibrierungspunkte, Markierungen, Türen, Buchten, Stapel)."
      },
      "createTrips": {
        "label": "Flüge erstellen",
        "description": "Erstelle neue Flüge und Reservierungen."
      },
      "deleteTrips": {
        "label": "Flüge löschen",
        "description": "Flüge und Reservierungen löschen."
      },
      "useFavorites": {
        "label": "Favoriten verwenden",
        "description": "Nutze die Favoriten-Funktion, um Favoriten-Stacks zu speichern, zu laden und zu bearbeiten."
      },
      "viewOnly": {
        "label": "Nur Anzeigen",
        "description": "Nur-Lesen-Modus: Benutzer kann alle Daten anzeigen, aber nichts erstellen, bearbeiten oder löschen."
      },
      "modifyRates": {
        "label": "Preise bearbeiten",
        "description": "Preise und Benchmark-Raten bearbeiten."
      },
      "modifyInfrastructure": {
        "label": "Infrastruktur bearbeiten",
        "description": "Kerninfrastruktur bearbeiten (Hangars, Vorfelder, Ausrüstung)."
      },
      "modifyConfiguration": {
        "label": "Konfiguration bearbeiten",
        "description": "FBO-Konfiguration anpassen (Serviceanzeige, Ops-Notiz-Tags)."
      }
    },
    "roles": {
      "fboAdmin": "FBO-Admin",
      "manager": "Manager",
      "operator": "Betreiber",
      "csr": "CSR"
    },
    "limitedAccess": {
      "title": "Begrenzter Zugriff",
      "message": "Du bist als {{role}} angemeldet. Nur FBO-Admins können Rollenberechtigungen anzeigen und bearbeiten. Wende dich an deinen Administrator, wenn du Zugriff benötigst."
    },
    "placeholders": {
      "airportCode": "KBZN",
      "timezone": "Zeitzone auswählen..."
    },
    "vipTags": {
      "title": "VIP-Tags",
      "description": "Konfiguriere VIP-Tags zur Klassifizierung von Stammkunden. Tags werden als farbige Badges bei Flugzeugen und Trips angezeigt.",
      "loading": "Lädt VIP-Tags...",
      "noTags": "Keine VIP-Tags konfiguriert. Füge unten deinen ersten Tag hinzu.",
      "addNew": "Tag hinzufügen",
      "fields": {
        "label": "Tag-Label",
        "newLabel": "Neues Tag-Label (z. B. VIP, YC)"
      },
      "buttons": {
        "add": "Hinzufügen"
      },
      "colorPicker": {
        "chooseColor": "Farbe wählen",
        "customColor": "Eigene Farbe..."
      },
      "success": {
        "created": "VIP-Tag erfolgreich erstellt",
        "deleted": "VIP-Tag erfolgreich gelöscht"
      },
      "errors": {
        "loadFailed": "Laden der VIP-Tags fehlgeschlagen",
        "createFailed": "Fehler beim Erstellen des VIP-Tags",
        "updateFailed": "VIP-Tag konnte nicht aktualisiert werden",
        "deleteFailed": "Löschen des VIP-Tags fehlgeschlagen",
        "reorderFailed": "Fehler beim Neuordnen der VIP-Tags"
      },
      "errorTitle": "Fehler beim Laden der VIP-Tags",
      "errorDescription": "Beim Laden der VIP-Tag-Einstellungen ist ein Fehler aufgetreten. Bitte aktualisiere die Seite."
    }
  },
  "userManagement": {
    "search": {
      "placeholder": "Suche nach E-Mail"
    },
    "table": {
      "headers": {
        "name": "Name",
        "email": "E-Mail",
        "role": "Rolle"
      }
    },
    "users": {
      "anonymous": "anonym",
      "noName": "---",
      "airplx": "AirPlx"
    },
    "buttons": {
      "delete": "Löschen"
    },
    "deleteDialog": {
      "title": "Benutzer löschen",
      "message": "Möchtest du {{userName}} wirklich löschen?",
      "confirm": "Ja, diesen Benutzer löschen"
    },
    "errors": {
      "noPermissionModifyRoles": "Du hast keine Berechtigung, Benutzerrollen zu ändern.",
      "cannotChangeOwnRole": "Du kannst deine eigene Rolle nicht ändern.",
      "cannotChangeAirplxRole": "Du kannst die Rolle von AirPlx-Mitarbeitern nicht ändern.",
      "failedToChangeRole": "Rollenänderung fehlgeschlagen. Bitte erneut versuchen.",
      "cannotDeleteSelf": "Du kannst dich nicht selbst löschen.",
      "cannotDeleteAirplx": "Du kannst AirPlx-Mitarbeiter nicht löschen.",
      "failedToDelete": "Löschen fehlgeschlagen. Bitte erneut versuchen."
    },
    "success": {
      "roleChanged": "Rolle für {{userName}} erfolgreich zu {{roleName}} geändert",
      "userDeleted": "Erfolgreich gelöscht: {{userName}}",
      "copiedToClipboard": "In Zwischenablage kopiert"
    },
    "invitations": {
      "title": "Einladung",
      "noInvites": "Keine ausstehenden Einladungen",
      "sentOn": "Gesendet am {{date}} um {{time}}",
      "buttons": {
        "copyLink": "Link kopieren",
        "delete": "Einladung löschen",
        "addTeamMember": "Mitglied hinzufügen",
        "invite": "Einladen"
      },
      "dialog": {
        "title": "Einladen",
        "instructions": "Lade einen neuen Benutzer zu AirPlx ein. Gib unten die E-Mail-Adresse ein – die Person erhält dann eine E-Mail mit Anweisungen, wie sie deinem Team beitreten kann.",
        "successMessage": "In {{email}}s Posteingang sollte eine E-Mail mit einer Einladung sein.",
        "alternativeLink": "Alternativ kannst du dem Benutzer diesen Link direkt senden:",
        "emailLabel": "E-Mail-Adresse",
        "roleLabel": "Rolle"
      },
      "emailWarning": {
        "title": "Persönliche E-Mail-Warnung",
        "message": "Du fügst ein Teammitglied mit einer E-Mail-Adresse außerhalb deiner Organisation hinzu. Persönliche E-Mail-Adressen (Gmail, iCloud, etc.) sind erlaubt, aber denk daran, den AirPlx-Zugang des Nutzers später bei Bedarf in den Einstellungen zu entfernen."
      }
    }
  },
  "integrations": {
    "title": "Integrationen",
    "subtitle": "Verbinde AirPlx mit externen Flugbetriebssystemen, um Flugpläne und Reservierungen automatisch zu synchronisieren.",
    "status": {
      "notConfigured": "Nicht konfiguriert",
      "disabled": "Deaktiviert",
      "enabled": "Aktiviert"
    },
    "lastSync": {
      "never": "Nie",
      "justNow": "Gerade eben",
      "minutesAgo": "vor {{count}} Minute",
      "hoursAgo": "vor {{count}} Stunde"
    },
    "flightBridge": {
      "name": "FlightBridge",
      "subtitle": "Flugbetriebsmanagement",
      "description": "Synchronisiere Flugpläne, Flugzeugdaten und Concierge-Reservierungen automatisch von der FlightBridge-Plattform.",
      "tooltips": {
        "credentialsVerified": "Anmeldedaten bestätigt",
        "cannotConnect": "Verbindung fehlgeschlagen – Zugangsdaten prüfen"
      },
      "labels": {
        "companyId": "Unternehmens-ID:",
        "airportCodes": "Flughafencodes:",
        "lastSync": "Letzt. Sync.:",
        "error": "Fehler:"
      },
      "buttons": {
        "configure": "Konfigurieren",
        "setUp": "Einricht.",
        "disable": "Deaktiv."
      },
      "disableDialog": {
        "title": "FlightBridge-Integration deaktivieren?",
        "message": "Die Synchronisierung wird sofort beendet. Du kannst sie jederzeit von dieser Seite aus wieder aktivieren.",
        "confirm": "Deaktiv."
      },
      "configDialog": {
        "title": "FlightBridge-Konfiguration",
        "tabs": {
          "basicConfig": "Grundkonfiguration",
          "locationMapping": "Standortzuordnung"
        },
        "fields": {
          "companyId": {
            "label": "Unternehmens-ID",
            "helper": "Deine FlightBridge-Firmenkennung"
          },
          "apiEnvironment": {
            "label": "API-Umgebung",
            "production": "Produktions-API (https://api.flightbridge.com)",
            "test": "Test-API (https://testapi.flightbridge.com)"
          },
          "airportCodes": {
            "label": "Flughafencodes",
            "placeholder": "KJFK, JFK",
            "helper": "Kommagetrennte ICAO/IATA-Codes. Nur Flüge mit Ankunft/Abflug an diesen Flughäfen werden importiert."
          },
          "username": {
            "label": "Benutzername"
          },
          "password": {
            "label": "Passwort"
          },
          "enabled": {
            "label": "Aktiviert",
            "tooltip": "Aktiviere die FlightBridge-Integration, um Flugpläne und Reservierungen automatisch zu synchronisieren. Wenn aktiviert, werden Trips aus FlightBridge importiert und erscheinen in deinem Zeitplan."
          },
          "syncLocationUpdates": {
            "label": "Standortaktualisierungen mit FlightBridge synchronisieren",
            "tooltip": "Wenn Flugzeuge in AirPlx bewegt werden (AutoPark, manuelle Bewegungen usw.), wird ihr Standort automatisch in FlightBridge aktualisiert. Updates erfolgen im Hintergrund innerhalb von 1–5 Sekunden."
          }
        },
        "buttons": {
          "test": "Verbindung testen & Datenvorschau",
          "testing": "Teste...",
          "viewPreview": "Datenvorschau anzeigen",
          "save": "Speichern",
          "saving": "Speichern...",
          "cancel": "Abbrechen"
        },
        "messages": {
          "testSuccess": "Authentifizierung erfolgreich! {{totalCount}} Reservierungen gefunden ({{filteredCount}} passend zu deinen Airport-Codes). Klicke auf Datenvorschau anzeigen für Details.",
          "testFailed": "Test fehlgeschlagen",
          "testInfo": "Klicke auf Verbindung testen & Datenvorschau, um deine FlightBridge-Zugangsdaten zu überprüfen und eine Vorschau der verfügbaren Daten zu sehen, bevor du speicherst.",
          "airportCodesRequired": "Flughafencodes sind erforderlich",
          "saveFailed": "Speichern der Konfiguration fehlgeschlagen"
        },
        "locationMapping": {
          "loading": "Lade Standortzuordnungen...",
          "emptyState": "Noch keine FlightBridge-Standorte gefunden. Klicke auf Verbindung testen & Daten anzeigen im Tab Basiskonfiguration, um Standorte aus deinem FlightBridge-Konto zu ermitteln.",
          "description": "Ordne FlightBridge-Standorte deinen AirPlx-Hangars und Vorfeldern zu. Diese Zuordnungen werden beim Synchronisieren von Concierge-Reservierungen verwendet.",
          "unmappedWarning": "{{count}} Standort noch nicht zugeordnet. Reservierungen für nicht zugeordnete Standorte werden keinem Hangar oder Vorfeld zugewiesen.",
          "table": {
            "headers": {
              "flightBridgeLocation": "FlightBridge-Standort",
              "airplxLocation": "AirPlx-Standort",
              "status": "Status"
            }
          },
          "menu": {
            "notMapped": "Nicht zugeord.",
            "hangars": "Hangars",
            "ramps": "Vorfeld"
          },
          "status": {
            "mapped": "Verknüpft",
            "unmapped": "Nicht zugew."
          },
          "help": "Standorte werden automatisch erkannt, wenn du die FlightBridge-Verbindung testest. Änderungen werden sofort gespeichert, wenn du eine Zuordnung auswählst.",
          "failedSync": "{{count}} Standortupdate konnte nicht mit FlightBridge synchronisiert werden",
          "retry": "Nochmal",
          "retrying": "Wird erneut...",
          "errors": {
            "failedToLoad": "Standortzuordnungen konnten nicht geladen werden",
            "failedToSave": "Zuordnung speichern fehlgeschlagen"
          }
        }
      },
      "dataPreviewDialog": {
        "title": {
          "success": "FlightBridge-Testergebnisse",
          "failed": "FlightBridge-Test fehlgeschlagen"
        },
        "auth": {
          "failed": "Authentifizierung fehlgeschlagen:",
          "success": "Erfolgreich angemeldet"
        },
        "errorDetails": {
          "title": "Technische Fehlerdetails",
          "message": "Nachricht:",
          "code": "Code:",
          "httpStatus": "HTTP-Status:"
        },
        "stats": {
          "dateRange": "Zeitraum",
          "totalReservations": "Reservierungen gesamt"
        },
        "table": {
          "title": "Beispielreservierungen (bis zu 10 angezeigt)",
          "headers": {
            "reservationId": "Reservierungs-ID",
            "tailNumber": "Kennzeichen",
            "locationOnField": "Standort am Flugfeld",
            "arrivalTime": "Ankunftszeit",
            "departureTime": "Abflugzeit",
            "status": "Status",
            "workflow": "Workflow",
            "services": "Dienste"
          },
          "values": {
            "notProvided": "Nicht angegeben",
            "unknown": "Unbekannt",
            "none": "Keine"
          }
        },
        "workflow": {
          "cancelled": "Abgebrochen",
          "requested": "Angefragt",
          "inProgress": "In Bearbeitung",
          "completed": "Abgeschlossen",
          "archived": "Archiviert",
          "rejected": "Abgelehnt",
          "unknown": "Unbekannt",
          "notApplicable": "—"
        },
        "noData": {
          "title": "Keine Reservierungen für dein Unternehmen in den letzten 7 Tagen gefunden. Das könnte bedeuten:",
          "reasons": {
            "noReservations": "Keine Concierge-Reservierungen erstellt",
            "outsideWindow": "Alle Reservierungen liegen außerhalb des 7-Tage-Fensters",
            "incorrectId": "Die Firmen-ID könnte falsch sein"
          }
        },
        "errors": {
          "title": "Fehler"
        },
        "footer": {
          "duration": "Test abgeschlossen in {{duration}}ms",
          "close": "Schließen"
        }
      }
    }
  },
  "opsCenter": {
    "airportConfig": {
      "title": "Flughafenkonfiguration",
      "subtitle": "Konfiguriere den Flughafencode und Namen für das Ops Center dieses FBO.",
      "icaoLabel": "ICAO-Code",
      "icaoPlaceholder": "KBZN",
      "icaoHelper": "Der 4-stellige ICAO-Flughafencode (z. B. KBZN, KJFK)",
      "nameLabel": "Flughafenname",
      "namePlaceholder": "Bozeman Yellowstone International",
      "nameHelper": "Anzeigename für den Flughafen"
    },
    "notifications": {
      "title": "Benachrichtigungseinstellungen",
      "subtitle": "Konfiguriere, welche Benachrichtigungen du im Ops Center erhältst.",
      "arrivingSoon": "Ankunft in Kürze",
      "etaChanges": "ETA-Änderungen",
      "landed": "Gelandet",
      "departed": "Abgeflogen",
      "alertLeadTime": "Vorlaufzeit Alarm",
      "leadTime15": "15 Minuten",
      "leadTime30": "30 Minuten",
      "leadTime60": "60 Minuten"
    },
    "uiPreferences": {
      "title": "UI-Einstellungen",
      "subtitle": "Konfiguriere die Ops Center-Benutzeroberfläche.",
      "showLivePositions": "Flugzeugpositionen live anzeigen"
    },
    "noteTags": {
      "title": "Notiz-Tags",
      "subtitle": "Eigene Tags für Flugnotizen verwalten.",
      "loading": "Lädt Tags...",
      "placeholder": "Neuer Tag-Name",
      "addButton": "Hinzufügen",
      "success": {
        "added": "Tag erfolgreich hinzugefügt",
        "removed": "Tag erfolgreich entfernt"
      },
      "errors": {
        "addFailed": "Tag-Hinzufügen fehlgeschlagen",
        "removeFailed": "Fehler beim Entfernen des Tags"
      }
    },
    "serviceDisplay": {
      "title": "Serviceanzeige",
      "subtitle": "Konfiguriere, welche Dienste als Badges angezeigt werden und in welcher Reihenfolge.",
      "loading": "Lädt Servicekonfiguration...",
      "sections": {
        "primaryBadges": "Primäre Abzeichen",
        "primaryDescription": "Diese Services werden als Badges in den Flugzeilen angezeigt. Zum Sortieren ziehen.",
        "otherServices": "Weitere Services",
        "otherDescription": "Diese Dienste sind verfügbar, werden aber nicht als Badges angezeigt."
      },
      "fields": {
        "label": "Anzeigebezeichnung"
      },
      "buttons": {
        "remove": "Entfernen",
        "add": "Neu"
      },
      "services": {
        "fuel": "Fuel",
        "hangar": "Hangar",
        "catering": "Catering",
        "hotel": "Hotel",
        "crewCar": "Crew-Auto",
        "limo": "Limo",
        "carRental": "Mietwagen",
        "arrivalLimo": "Ankunfts-Limousine",
        "departureLimo": "Abfahrtslimousine",
        "deicing": "Enteisung",
        "groundPower": "Bodenstrom",
        "gpu": "GPU",
        "lavatory": "Toilette",
        "water": "Wasser",
        "towing": "Schleppen",
        "oxygen": "Sauerstoff",
        "conferenceRoom": "Konferenzraum",
        "customs": "Zoll",
        "payment": "Zahlung",
        "dishes": "Gerichte",
        "linens": "Wäsche",
        "otherArrival": "Sonstiges (Ankunft)",
        "otherDeparture": "Sonstiges (Abflug)",
        "cip": "Cip",
        "confRoomShort": "Konferenzraum kurz",
        "lav": "WC"
      },
      "success": {
        "movedToPrimary": "Service zu primären Badges verschoben",
        "movedToOther": "Dienst zu anderen Diensten verschoben"
      },
      "errors": {
        "loadFailed": "Dienstkonfiguration konnte nicht geladen werden",
        "updateFailed": "Aktualisierung fehlgeschlagen",
        "reorderFailed": "Neuordnung der Dienste fehlgeschlagen"
      }
    }
  },
  "hangarSettings": {
    "title": "Stammmieter für {{hangarName}}",
    "table": {
      "headers": {
        "name": "Hangarname",
        "dimensions": "Abmessungen",
        "wallSpacing": "Wandabstand",
        "baseTenants": "Basiskunden"
      }
    },
    "buttons": {
      "modify": "Ändern",
      "delete": "Löschen",
      "copy": "Kopie",
      "cancel": "Abbrechen",
      "uploadImage": "Referenzbild hochladen",
      "cancelSetup": "Setup abbrechen",
      "saveHangar": "Hangar speichern"
    },
    "copyDialog": {
      "title": "Hangar kopieren",
      "fboLabel": "Zu FBO kopieren",
      "copyButton": "Hangar kopieren"
    },
    "deleteDialog": {
      "title": "Möchtest du {{hangarName}} wirklich löschen?",
      "message": "Dieser Hangar und alle zugehörigen Mieterinformationen werden gelöscht. Alle Stammmieter dieses Hangars werden nicht mehr zugewiesen sein.",
      "confirmButton": "Hangar löschen"
    },
    "emptyState": {
      "title": "Keine Hangars konfiguriert",
      "description": "Klicke oben auf Hangar hinzufügen, um deinen ersten Hangar zu konfigurieren."
    },
    "tabs": {
      "basicInfo": "Basisinfos",
      "dimensions": "Abmessungen",
      "heightBays": "Höhe & Buchten",
      "features": "Funktionen"
    },
    "titles": {
      "editHangar": "Hangar bearbeiten: {{name}}"
    },
    "confirmations": {
      "saveChanges": {
        "title": "Änderungen speichern?",
        "message": "Möchtest du diese Änderungen wirklich speichern?"
      }
    },
    "labels": {
      "referenceImage": "Referenzbild",
      "display": "Anzeigen?",
      "untitled": "Ohne Titel",
      "autostackingEnabled": "Autostacking aktiviert?"
    },
    "success": {
      "saved": "Hangaränderungen gespeichert."
    },
    "errors": {
      "unknown": "Unbekannter Fehler",
      "saveFailed": "Speichern fehlgeschlagen: {{error}}"
    },
    "dimensionsForm": {
      "labels": {
        "hangarName": "Hangarname",
        "width": "Breite ({{unit}})",
        "depth": "Tiefe ({{unit}})",
        "grossSquareFootage": "Bruttofläche (ft²)",
        "usableSquareFootage": "Nutzbare Quadratmeterzahl",
        "doorPockets": "Türfächer",
        "leftDoorLength": "Linke Türlänge ({{unit}})",
        "rightDoorLength": "Rechte Türlänge ({{unit}})",
        "doorDimensions": "Türmaße",
        "doorWidth": "Breite ({{unit}})",
        "heightConfiguration": "Höhenkonfiguration",
        "useBayHeights": "Nutze buchtspezifische Höhen",
        "height": "Höhe ({{unit}})",
        "garageDoors": "Garagentore",
        "noGarageDoors": "Keine Hangartore. Klicke auf Hinzufügen.",
        "wall": "Wand",
        "wallLeft": "Links",
        "wallBack": "Zurück",
        "wallRight": "Rechts",
        "garageDoorWidth": "Breite",
        "obstacles": "Hindernisse",
        "wallSpacing": "Wandabstand",
        "leftWall": "Linke Wand ({{unit}})",
        "backWall": "Rückwand ({{unit}})",
        "rightWall": "Rechte Wand ({{unit}})"
      },
      "obstacleHint": "Nutze die Werkzeugleiste über der Zeichenfläche, um rechteckige oder polygonale Hindernisse hinzuzufügen.",
      "tooltips": {
        "bayHeights": "Für Hangars mit gestufter Traufe und unterschiedlichen Höhenzonen aktivieren. Jedes Feld kann eigene Trauf- und lichte Höhen haben.",
        "eaveHeight": "Traufhöhe für einheitliche Hangars. Dies ist der vertikale Abstand vom Boden bis zum tiefsten Punkt der Dachkonstruktion."
      }
    },
    "bayEditor": {
      "orientations": {
        "lateral": "Lateral (nebeneinander)",
        "longitudinal": "Längs (Vorne-Hinten)"
      },
      "tooltips": {
        "lateral": "┌──┬───┬──┐\n│A │ B │C │\n│  │   │  │\n└──┴───┴──┘\nBereiche von links→rechts\nBeispiel: 3 Bereiche mit 24m, 30m, 24m",
        "longitudinal": "┌─────────┐\n│    A    │\n├─────────┤\n│    B    │\n└─────────┘\nBays teilen vorne→hinten\nBeispiel: 2 Bays à 60ft, 60ft",
        "bayRange": "Stellplatz umfasst {{start}}{{unit}} - {{end}}{{unit}}",
        "baySegment": "Bay {{index}}: {{start}}–{{end}}{{unit}} ({{percent}} %)"
      },
      "labels": {
        "width": "Breite ({{unit}})",
        "depth": "Tiefe ({{unit}})",
        "eaveHeight": "Traufhöhe ({{unit}})",
        "clearHeight": "Freigabehöhe ({{unit}})"
      },
      "coverage": {
        "total": "Gesamt: {{total}} {{unit}} / {{hangar}} {{unit}} ({{percent}}%)",
        "complete": "✓ Vollständige Abdeckung",
        "exceeds": "⚠️ Überschreitet um {{gap}}{{unit}}",
        "missing": "⚠️ {{gap}}{{unit}} fehlt",
        "uncovered": "Nicht abgedeckt {{dimension}}: {{start}}{{unit}} - {{end}}{{unit}}",
        "overflowIndicator": "+{{gap}}{{unit}}"
      },
      "buttons": {
        "addBay": "Hinzufügen",
        "fillRemainder": "Restmenge füllen ({{gap}}{{unit}})"
      }
    },
    "newAircraftForm": {
      "labels": {
        "ownerManager": "Inhaber/Manager",
        "type": "Typ",
        "notes": "Notizen",
        "unassigned": "Nicht zugew.",
        "notHangared": "Nicht im Hangar"
      },
      "types": {
        "base": "Basis",
        "transient": "Durchreisend",
        "yellowCard": "Basis + Gelbe Karte"
      },
      "placeholders": {
        "departureTime": "Abflugzeit: 24.05.2025 12:00"
      }
    },
    "obstacleContextMenu": {
      "copy": "Kopie",
      "delete": "Löschen"
    },
    "obstacleToolbar": {
      "addObstacleTooltip": "Hindernis +",
      "addObstacleButton": "Hindernis +",
      "rightClickHint": "Rechtsklick zum Löschen eines Hindernisses",
      "dialogTitle": "Hindernis/No-Tow-Bereich hinzufügen",
      "polygonDialogTitle": "Polygon-Hindernis hinzufügen",
      "tools": {
        "select": "Auswählen",
        "rectangle": "Rechteck",
        "polygon": "Polygon",
        "circle": "Circle"
      },
      "polygonHints": {
        "clickToAddPoints": "Punkte hinzufügen",
        "minThreePoints": "Füge mindestens 3 Punkte hinzu",
        "clickFirstPointToClose": "Ersten Punkt klicken zum Schließen"
      },
      "circleHints": {
        "clickToPlaceCenter": "Click to place center point"
      },
      "circleDialogTitle": "Add Circle Obstacle",
      "circleInfo": "Circle Info",
      "centerPosition": "Center",
      "polygonInfo": "Polygon-Info",
      "pointCount": "Punkte",
      "boundingBox": "Begrenzungsrahmen",
      "heightHint": "Höhe ist optional. Gib sie an, wenn das Hindernis Höhenbeschränkungen für die Flugzeugpositionierung hat.",
      "obstacleTypes": {
        "obstruction": "Hindernis",
        "noTowArea": "Schleppverbot",
        "unobstructive": "unauffällig",
        "caution": "Achtung"
      },
      "labels": {
        "type": "Typ",
        "width": "Breite ({{unit}})",
        "depth": "Tiefe ({{unit}})",
        "height": "Höhe ({{unit}})",
        "diameter": "Diameter ({{unit}})"
      },
      "buttons": {
        "cancel": "Abbrechen",
        "add": "Neu"
      }
    },
    "bulkAdd": {
      "tabs": {
        "byMakeModel": "Hersteller & Modell hinzufügen",
        "byTailNumbers": "Nach Kennzeichen hinzufügen"
      },
      "labels": {
        "searchByMakeModel": "Suche nach Hersteller und Modell",
        "numAircraft": "# Flugzeuge",
        "tailNumbers": "Kennzeichen",
        "selectAircraftType": "Flugzeugtyp auswählen"
      },
      "placeholders": {
        "tailNumbersMultiline": "N12345\nN54321\nN67890",
        "tailNumbersComma": "z. B. N12345, N54321, N67890"
      },
      "buttons": {
        "search": "Suchen",
        "addAircraft": "Flugzeug hinzuf.",
        "remove": "Entfernen",
        "addMoreTailNumbers": "Weitere Kennzeichen hinzufügen",
        "add": "Neu"
      },
      "messages": {
        "enterOneTailPerLine": "Gib pro Zeile eine Kennzeichnung ein.",
        "allTailsFound": "✓ Alle Kennzeichen in der Datenbank gefunden",
        "unknownTailNumbersTitle": "Unbekannte Kennzeichen",
        "unknownTailNumbersInstructions": "Die folgenden Kennzeichen wurden nicht in der Datenbank gefunden. Bitte wähle für jedes den Flugzeugtyp aus oder entferne sie:",
        "aircraftAddedToList": "✓ Flugzeuge wurden zur Liste hinzugefügt",
        "maxAircraftWarning": "Maximal 20 Flugzeuge können hinzugefügt werden.",
        "existingTailNumberWarning": "Flugzeug mit Kennzeichen {{tailNumber}} existiert bereits. Wir haben das vorhandene Kennzeichen und das zugehörige Flugzeugmodell hinzugefügt.",
        "tailNumbersOptional": "Optional. Trenne Kennzeichen mit Kommas."
      },
      "table": {
        "headers": {
          "tailNumber": "Kennz.",
          "model": "Modell",
          "type": "Typ",
          "direction": "Richtung"
        }
      }
    },
    "tenantSelector": {
      "table": {
        "headers": {
          "lastHangared": "Zuletzt im Hangar"
        }
      },
      "search": {
        "placeholder": "Suche nach Mietername oder Tail #"
      },
      "buttons": {
        "removeAircraft": "Flugzeug entfernen",
        "addAircraft": "Flugzeug hinzuf."
      },
      "status": {
        "inLocation": "In {{locationName}}"
      },
      "dialog": {
        "confirmTitle": "Bitte bestätigen"
      },
      "messages": {
        "aircraftAdded": "{{model}} zu {{locationName}} hinzugefügt"
      }
    },
    "autocompleteAircraft": {
      "defaultLabel": "Flugzeug",
      "suggested": "(vorgeschlagen)",
      "noOptionsButton": "Kein Flugzeug gefunden • Hier klicken, um ein neues Flugzeug anzufordern",
      "newAircraftRequest": {
        "title": "Neue Flugzeuganfrage",
        "successTitle": "Anfrage erhalten",
        "labels": {
          "manufacturer": "Hersteller",
          "model": "Modell",
          "uniqueModifiers": "Einzigartige Merkmale (z. B. Winglets, Varianten)",
          "timeframe": "Zeitraum"
        },
        "messages": {
          "successMessage": "Danke! Wir kümmern uns so schnell wie möglich darum. Falls wir Fragen zu den Details des Flugzeugs haben, das du hinzufügen möchtest, melden wir uns per E-Mail – bitte behalte deinen Posteingang im Blick.",
          "uploadTimeframe": "Erlaube 2–4 Tage für das Hochladen neuer Flugzeugmodelle. Wir benachrichtigen dich, sobald es verfügbar ist."
        }
      }
    },
    "addTripTab": {
      "labels": {
        "ownerManager": "Inhaber/Manager",
        "type": "Typ",
        "notes": "Notizen",
        "arrivalDateTime": "Ankunftsdatum & -uhrzeit",
        "departureDateTime": "Abflugdatum & -zeit",
        "noDeparture": "Kein Abflug"
      },
      "placeholders": {
        "ownerManager": "z. B. Max Mustermann",
        "notes": "Optionale Notizen zu diesem Flug..."
      },
      "tenantTypes": {
        "transient": "Durchreisend",
        "base": "Basis",
        "yellowCard": "Basis + Gelbe Karte"
      },
      "messages": {
        "noDepartureInfo": "Dieses Flugzeug bleibt auf unbestimmte Zeit am FBO ohne geplanten Abflug.",
        "existingTrips": "Bestehende Flüge für {{tailNumber}}:",
        "avoidOverlap": "Bitte wähle andere Daten, um Überschneidungen zu vermeiden",
        "checkDatesWarning": "Überprüfe die Daten, um Überschneidungen zu vermeiden – wir lassen keine überlappenden Flüge zu",
        "autoAssignedInfo": "Dieser Trip wird automatisch dem aktuellen {{locationType}} zugewiesen.",
        "overlapError": "Ein anderer Trip überschneidet sich mit diesem Zeitraum. Bitte aktualisiere die Seite und wähle andere Daten."
      }
    },
    "allTripsTab": {
      "labels": {
        "unassigned": "Nicht zugew.",
        "startDate": "Startdatum",
        "endDate": "Enddatum"
      },
      "placeholders": {
        "filterTailOrOwner": "Kennzeichen/Eigentümer"
      },
      "status": {
        "cancelled": "Abgebrochen",
        "past": "Früher",
        "active": "Aktiv",
        "future": "Zukunft",
        "today": "Heute",
        "tomorrow": "Morgen",
        "thisWeek": "Diese Woche",
        "nextWeek": "Nächste Woche",
        "thisMonth": "Diesen Monat"
      },
      "columns": {
        "tailNumber": "Kennzeichen",
        "arrival": "Ankunft",
        "departure": "Abflug",
        "duration": "Dauer",
        "status": "Status",
        "location": "Standort",
        "actions": "Aktionen"
      },
      "buttons": {
        "hidePast": "Vergangene aus",
        "showPast": "Vergangene",
        "delete": "Löschen"
      },
      "dialogs": {
        "deleteTitle": "Flüge löschen?"
      },
      "errors": {
        "loadFailed": "Flüge laden fehlgeschlagen",
        "selectLocation": "Bitte wähle einen Standort aus dem Filter-Dropdown, bevor du Trips zuweist",
        "locationNotFound": "Ausgewählter Standort nicht gefunden",
        "assignFailed": "Zuweisung der Trips fehlgeschlagen",
        "unassignFailed": "Flugzuweisung fehlgeschlagen",
        "cancelFailed": "Flüge stornieren fehlgeschlagen",
        "deleteFailed": "Löschen der Flüge fehlgeschlagen"
      }
    },
    "addSelectedTenant": {
      "table": {
        "headers": {
          "tailNumber": "Kennz.",
          "model": "Modell",
          "currentLocation": "Aktueller Standort",
          "lastHangared": "Zuletzt im Hangar",
          "type": "Typ"
        }
      },
      "status": {
        "inHoldingArea": "Im Wartebereich",
        "inThisHangar": "In diesem Hangar",
        "inLocation": "In {{locationName}}"
      },
      "buttons": {
        "add": "Neu"
      },
      "unassignedText": "Nicht im Hangar"
    },
    "customizeHeatmap": {
      "loading": "Lädt..."
    }
  },
  "stackingSOPs": {
    "titles": {
      "hangarStacking": "Hangar-Stapelung",
      "normalSpacing": "Normaler Abstand",
      "looseSpacing": "Lockerer Abstand",
      "tightSpacing": "Enger Abstand",
      "rampSpacing": "Abstellabstand"
    },
    "labels": {
      "horizontalSpacing": "Horizontaler Abstand ({{unit}})",
      "verticalSpacing": "Vertikaler Abstand ({{unit}})",
      "allowOverlap": "Überlappung erlauben?"
    },
    "noseInThresholds": {
      "title": "Nose-In/Tail-In-Einstellungen",
      "tooltipText": "AirPlx verwendet die niedrigere Höhenmessung des Höhenleitwerks, um die Standardausrichtung zu bestimmen, wenn ein neues Flugzeug zu einem Hangar hinzugefügt wird. Verwende den Schieberegler unten, um die Höhenleitwerk-Höhe anzupassen, bei der AirPlx standardmäßig auf Heck-rein, Keine Vorgabe oder Nase-rein setzt. Beispiel:",
      "tooltipExamples": {
        "allTailIn": "Wenn du alle Flugzeuge mit dem Heck voran parken möchtest, schiebe beide Regler ganz nach rechts.",
        "below20TailIn": "Wenn du möchtest, dass alle Flugzeuge unter 20{{unit}} mit dem Heck und alle anderen mit der Nase zuerst einparken, schiebe beide Regler auf 20{{unit}}."
      },
      "tooltipNote": "Hinweis: Du kannst die Ausrichtung einzelner Flugzeuge in jedem Hangar nach Belieben anpassen.",
      "orientations": {
        "tailIn": "Ankunft",
        "noPreset": "Keine Vorlage",
        "noseIn": "Bugzuerst"
      },
      "resetButton": "Auf Standard zurücksetzen"
    },
    "tabs": {
      "baseWide": "Standortweite SOPs",
      "locationOverrides": "Standort-Überschreibungen"
    },
    "baseWide": {
      "description": "Konfiguriere die Standardeinstellungen für Abstände und Ausrichtung, die für alle Hangars und Vorfelder gelten. Diese können pro Standort im Tab Standort-Überschreibungen angepasst werden."
    },
    "overrides": {
      "name": "Name",
      "status": "Status",
      "actions": "Aktionen",
      "edit": "Bearb.",
      "overrideCount": "{{count}} Überschreibung(en)",
      "usingBaseWide": "Standortweite SOPs verwenden",
      "description": "Überschreibe die standortweiten SOP-Einstellungen für bestimmte Hangars oder Vorfelder. Standorte ohne Überschreibungen verwenden die standortweiten Einstellungen.",
      "hangars": "Hangars",
      "ramps": "Vorfelder",
      "noHangars": "Keine Hangars konfiguriert",
      "noRamps": "Keine Vorfelder konfiguriert",
      "editTitle": "SOP-Überschreibungen für {{name}}",
      "editDescription": "Standortweite SOP-Einstellungen für diesen Standort überschreiben. Felder leer lassen, um den standortweiten Standard zu verwenden.",
      "orientationThresholds": "Orientierungsschwellenwerte",
      "fboDefault": "FBO-Standard: {{value}}",
      "resetAll": "Zurücksetzen",
      "saveSuccess": "SOP-Überschreibungen erfolgreich gespeichert",
      "saveError": "SOP-Überschreibungen nicht gespeichert"
    }
  },
  "rampsSettings": {
    "buttons": {
      "addRamp": "Vorfeld +",
      "modify": "Ändern",
      "delete": "Löschen",
      "copy": "Kopie",
      "cancel": "Abbrechen"
    },
    "table": {
      "headers": {
        "name": "Vorfeldname",
        "dimensions": "Abmessungen"
      }
    },
    "copyDialog": {
      "title": "Vorfeld kop.",
      "fboLabel": "Zu FBO kopieren",
      "copyButton": "Vorfeld kop."
    },
    "deleteDialog": {
      "title": "Möchtest du {{rampName}} wirklich löschen?",
      "message": "Dieses Vorfeld und alle zugehörigen Einstellungen werden gelöscht.",
      "confirmButton": "Vorfeld löschen"
    },
    "emptyState": {
      "title": "Keine Vorfelder konfiguriert",
      "description": "Klicke oben auf Vorfeld hinzufügen, um dein erstes Vorfeld zu konfigurieren."
    },
    "labels": {
      "rampName": "Vorfeldname",
      "width": "Breite ({{unit}})",
      "depth": "Tiefe ({{unit}})"
    },
    "rampEditorForm": {
      "editRamp": "Bearbeiten",
      "boundingBoxCoordinates": "Begrenzungsrahmen-Koordinaten",
      "coordinates": {
        "topLeft": "Oben links",
        "topRight": "Oben rechts",
        "bottomRight": "Unten rechts",
        "bottomLeft": "Unten links"
      },
      "confirmations": {
        "saveChanges": {
          "message": "Speichern",
          "title": "Speichern"
        }
      },
      "messages": {
        "needCalibrationPoints": "Kalibrierungspunkte erforderlich"
      }
    },
    "rampEditor": {
      "title": "Vorfeld bearb.",
      "saveSuccess": "Ramp-Änderungen gespeichert.",
      "properties": "Properties",
      "rampVersion": "Ramp Version",
      "v2Algorithm": "V2 Algorithm",
      "editName": "Zum Umbenennen klicken",
      "namePlaceholder": "Vorfeldname eingeben",
      "unsavedChanges": {
        "title": "Nicht gespeichert",
        "message": "Du hast ungespeicherte Änderungen. Möchtest du wirklich beenden?",
        "exitButton": "Beenden ohne Speichern",
        "stayButton": "Hier"
      },
      "gisShapeEditGrid": {
        "warningOutOfBounds": "Diese Form ist möglicherweise außerhalb des aktuellen Ramp-Bereichs nicht sichtbar",
        "placeholderShapeText": "Formtext",
        "presetLabel": "Vorlage",
        "strokeLabel": "Strich",
        "fillLabel": "Füllen",
        "doneButton": "Fertig",
        "noShapes": "Keine Formen vorhanden",
        "instructions": "Klicke auf Text/Label oder Schriftgröße, um direkt zu bearbeiten. Nutze das Bearbeiten-Symbol für Farben und Tags.",
        "applyDefaultStyling": "Standardformatierung anwenden",
        "headers": {
          "textLabel": "Text/Label",
          "tags": "Tags",
          "colors": "Farben",
          "fontSize": "Schriftgröße",
          "actions": "Aktionen"
        },
        "shapeCount": "Anzahl Formen"
      },
      "toolbar": {
        "selectSpotSize": "Select spot size",
        "sections": {
          "options": "Optionen",
          "calibrationPoints": "Kalibrierpunkte"
        },
        "options": {
          "image": "Bild",
          "measurements": "Messungen",
          "rampV2": "Ramp v2.0",
          "autoParking": "AutoParking",
          "guideLines": "Richtlinien",
          "showPoints": "Punkte anzeigen"
        },
        "tooltips": {
          "downloadImage": "Ramp-Bild herunterladen",
          "uploadImage": "Neues Vorfeldbildes hochladen",
          "compressImage": "Bestehendes Bild komprimieren"
        },
        "tabs": {
          "tools": "Tools",
          "shapes": "Formen",
          "hangars": "Hangars"
        },
        "buttons": {
          "finishedAdding": "Hinzugefügt",
          "addPoint": "Hinzufügen"
        },
        "bulkOperations": "Massenoperationen",
        "noHangarsAvailable": "Keine Hangars verfügbar",
        "spotSizes": {
          "verySmall": "Sehr klein (x40ft)",
          "small": "Klein (x60ft)",
          "midsize": "Mittelgroß (x80ft)",
          "superMid": "S-Mid (x100 Fuß)",
          "large": "Groß (x120ft)"
        },
        "snackbar": {
          "imageSaved": "Gespeichert: {{kb}} KB ({{percent}} %)",
          "compressionFailed": "Bild konnte nicht komprimiert werden. Details in der Konsole."
        }
      },
      "referenceAircraft": {
        "toolButton": "Referenzflugzeug",
        "toolTooltip": "Referenzflugzeug für Größenvergleich hinzufügen",
        "dialog": {
          "title": "Referenzflugzeug auswählen",
          "description": "Wähle ein Flugzeug als Maßstabsreferenz für die Zeichenfläche. Ziehen zum Verschieben, R drücken zum Drehen.",
          "searchLabel": "Flugzeug suchen",
          "currentAircraft": "Ausgewähltes Flugzeug",
          "dimensions": "{{wingspan}}ft Spannweite x {{length}}ft Länge",
          "clearButton": "Referenz entfernen",
          "applyButton": "Anwenden",
          "cancelButton": "Abbrechen"
        },
        "hints": {
          "drag": "Ziehen zum Bewegen",
          "rotate": "R zum Drehen, Umschalt+R gegen den Uhrzeigersinn",
          "delete": "Löschen zum Entfernen"
        }
      },
      "rampInitialize": {
        "title": "Neues Vorfeld erstellen",
        "rampNameLabel": "Vorfeldname",
        "uploadImageButton": "Ramp-Referenzbild hochladen",
        "calibrationInstructions": "Bitte erstelle eine Referenzlinie auf dem Bild. Wir verwenden diese, um den Maßstab deines Vorfelds von Pixeln auf {{unit}} zu kalibrieren.",
        "redoButton": "Vor",
        "confirmButton": "Sieht gut aus",
        "continueButton": "Continue to Setup",
        "dropImageHint": "Drag & drop a ramp image here",
        "setupHint": "After uploading, you'll calibrate the image using GPS coordinates to set accurate dimensions."
      },
      "compassRoseExists": "Compass rose already exists on this ramp",
      "recalibrate": "Recalibrate GPS",
      "calibrationPointDialog": {
        "position": "Position: ({{x}}, {{y}})",
        "addButton": "Hinzufügen",
        "cancelButton": "Abbrechen-Button",
        "coordinatesLabel": "Koordinaten-Beschriftung",
        "coordinatesPlaceholder": "Koordinaten eingeben",
        "latitudeLabel": "Breitengrad-Label",
        "longitudeLabel": "Längengrad-Label",
        "titleAdd": "Titel hinzu",
        "titleEdit": "Titel ändern",
        "updateButton": "Aktualisieren-Btn"
      },
      "calibrationPointsList": {
        "noPoints": "Keine Kalibrierungspunkte definiert",
        "position": "Position"
      },
      "rampCanvasToolbar": {
        "typeLabel": "Typ",
        "tools": {
          "measuringTool": "Messwerkzeug",
          "modifyOutline": "Gliederung bearbeiten",
          "addHazard": "Gefahr +",
          "unknown": "Unbekannt"
        },
        "tooltips": {
          "save": "Speichern",
          "delete": "Löschen"
        },
        "markingTypes": {
          "whiteSolid": "Weiß Vollton",
          "whiteDashed": "Weiß gestrichelt",
          "yellowSolid": "Gelb Durchgezogen",
          "yellowDashed": "Gelb gestrichelt",
          "redSolid": "Rot, massiv",
          "grey": "Grau"
        }
      },
      "spotTilePicker": {
        "hoverPrompt": "Zum Vorschauen über Punkt fahren",
        "gridSize": "Raster: {{width}}x{{height}}"
      },
      "gisImport": {
        "title": "GIS-Daten importieren",
        "sections": {
          "formatRequirements": "Formatanforderungen",
          "importedShapes": "Importierte Formen ({{count}})"
        },
        "format": {
          "delimiter": "<strong>Trennzeichen:</strong> Tabulator-getrennt (TSV)",
          "requiredColumns": "<strong>Erforderliche Spalten:</strong> geometry (WKT-Format)",
          "optionalColumns": "<strong>Optionale Spalten:</strong> ramp_label, stroke_color, fill_color, font_size",
          "sampleNote": "Lade die Beispieldatei unten als Referenz herunter."
        },
        "defaults": {
          "shapeName": "Importierte Form"
        },
        "buttons": {
          "cancel": "Abbrechen",
          "downloadSample": "Beispiel herunterladen",
          "processCSV": "Datei verarbeiten",
          "import": "{{count}} Formen importieren"
        },
        "errors": {
          "calibrationPoints": "Für die Koordinatentransformation sind mindestens 2 Kalibrierungspunkte erforderlich",
          "processingFailed": "Dateiverarbeitung fehlgeschlagen"
        }
      },
      "spotProperties": {
        "disabled": {
          "label": "Deaktiviert",
          "tooltip": "Wenn aktiviert, wird dieser Stellplatz von AutoPark-Berechnungen ausgeschlossen"
        },
        "allowedSizes": {
          "label": "Erlaubte Flugzeuggrößen",
          "tooltip": "Lege fest, welche Flugzeuggrößen hier parken dürfen. Kleinere Größen sind immer erlaubt, wenn größere zugelassen sind.",
          "spotSize": "Stellplatz geeignet für: ~{{feet}}ft Spannweite ({{category}})",
          "tooLarge": "(zu groß)"
        },
        "egressLanes": {
          "label": "Ausfahrtspuren",
          "tooltip": "Wähle aus, welche Lanes dieser Spot für den Egress nutzen kann. Flugzeuge werden hier nur platziert, wenn mindestens eine Egress-Lane verfügbar ist.",
          "noneSelected": "Keine Auswahl",
          "noLanesDefined": "Keine Fahrspuren für dieses Vorfeld",
          "laneLabel": "Spur {{id}}"
        },
        "gapSpot": {
          "label": "Lückenplatz",
          "tooltip": "Gap-Positionen dienen als Pufferzonen zwischen Flugzeugen. Wenn aktiviert, kann diese Position nur genutzt werden, wenn alle erforderlichen Nachbarpositionen belegt sind.",
          "checkboxLabel": "Als Lückenplatz aktivieren",
          "requiredSpots": "Erforderliche Plätze (müssen alle belegt sein):",
          "noneDetected": "Keine angrenzenden Stellplätze erkannt"
        },
        "maxDwellTime": {
          "label": "Max. Verweildauer",
          "tooltip": "Maximale Verweildauer eines Luftfahrzeugs auf diesem Stellplatz (z. B. für Quick-Turn-Positionen)",
          "inputLabel": "Max. Stunden",
          "placeholder": "Kein Limit",
          "helperText": "Leer lassen für kein Limit"
        },
        "minDwellTime": {
          "label": "Min. Verweildauer",
          "tooltip": "Mindestzeit, die ein Flugzeug auf diesem Stellplatz bleiben muss (z. B. für reine Übernachtungsplätze)",
          "inputLabel": "Min. Stunden",
          "placeholder": "Kein Minimum",
          "helperText": "Leer lassen für kein Minimum"
        },
        "blockingSpots": {
          "label": "Blockierungsbeziehungen",
          "tooltip": "Zeigt, welche Spots diesen Spot blockieren und welche Spots dieser Spot blockiert",
          "none": "Keine Blockierbeziehungen",
          "noBlocks": "Blockiert keine Plätze"
        },
        "tiling": {
          "label": "Spot-Kachelung",
          "tooltip": "Erstelle ein Raster von Spots basierend auf den Maßen dieses Spots",
          "button": "Kachelraster erstellen",
          "bufferLabel": "Puffer (ft)"
        }
      },
      "shapeEdit": {
        "mixedTypes": "Mixed shape types",
        "actions": {
          "delete": "Löschen",
          "copy": "Kopie",
          "cancel": "Abbrechen",
          "ok": "OK"
        },
        "algorithm": {
          "referencePoints": "Referenzpunkte",
          "orientations": {
            "nose": "Bug",
            "tail": "Kz.",
            "overhang": "Überhang",
            "center": "Mitte"
          },
          "refPoints": {
            "north": {
              "label": "Nord",
              "tooltip": "Referenzpunkt auf der Nordseite des Standplatzes"
            },
            "south": {
              "label": "Süd",
              "tooltip": "Referenzpunkt auf der Südseite des Spots"
            },
            "east": {
              "label": "Ost",
              "tooltip": "Referenzpunkt auf der Ostseite des Spots"
            },
            "west": {
              "label": "West",
              "tooltip": "Referenzpunkt auf der Westseite des Standplatzes"
            },
            "center": {
              "label": "Mitte",
              "tooltip": "Referenzpunkt in der Mitte des Spots"
            }
          },
          "noValue": "—",
          "zoneProperties": "Zoneneigenschaften",
          "zoneDisabled": {
            "label": "Deaktiviert",
            "tooltip": "Wenn aktiviert, wird diese Zone von AutoPark-Berechnungen ausgeschlossen"
          },
          "stagingArea": {
            "label": "Staging-Bereich",
            "tooltip": "Markiere diese Zone als Bereitstellungsbereich für temporäre Aircraft-Positionierung"
          },
          "overflowParking": {
            "label": "Überlaufparkplatz",
            "tooltip": "Nutze diese Zone als Ausweichfläche, wenn die Hauptpositionen belegt sind"
          },
          "zoneName": {
            "label": "Zonenname",
            "placeholder": "Zonenname eingeben",
            "helperText": "Optionaler Anzeigename für diese Zone"
          },
          "zonePriority": "Zonenpriorität",
          "zonePriorityHelp": "Zonen mit höherer Priorität werden bevorzugt für das Parken (0=niedrigste, 10=höchste)",
          "aircraftOrientation": "Flugzeugausrichtung",
          "noseToLine": "Nase zur Linie",
          "priority": "Priorität",
          "settings": "Einstellung",
          "tailToLine": "Flugzeug zur Linie"
        },
        "properties": {
          "locked": "Gesperrt",
          "tags": "Tags",
          "text": "Text"
        },
        "styling": {
          "color": "Farbe",
          "custom": "Eigene",
          "fill": "Füllen",
          "fontSize": "Schriftgröße",
          "line": "Zeile",
          "lineStyle": "Linienstil",
          "lineWidth": "Linienbreite",
          "pattern": "Muster",
          "prefixedColors": "Farbpräfixe",
          "showText": "Text anzeigen",
          "text": "Text",
          "textPosition": "Textposition"
        },
        "tabs": {
          "algorithm": "Algorithmus",
          "properties": "Eigenschaften",
          "styling": "Gestaltung"
        },
        "title": "Formbearbeitung"
      },
      "canvasTextInput": {
        "title": "Bearbeiten",
        "nameLabel": "Text",
        "cancel": "Abbrechen",
        "save": "Speichern"
      },
      "egressCalculation": {
        "close": "Schließ",
        "details": {
          "blocksLabel": "Blöcke-Label",
          "gapSpotNote": "Lückennotiz",
          "title": "Details"
        },
        "spotAnalysis": {
          "blockedByTooltip": "Blockiert durch Tooltip",
          "blocksTooltip": "Blöcke-Tooltip",
          "headers": {
            "blockedByCount": "Blockiert von (Anzahl)",
            "blockingCount": "Anzahl Blockierungen",
            "egressLane": "Ausfahrspur",
            "egressLaneTooltip": "Ausfahrtspur-Tooltip",
            "hasLane": "Hat Lane",
            "spot": "Spot",
            "status": "Status"
          },
          "noLane": "Keine Spur",
          "title": "Standplatzanalyse",
          "zeroCount": "Anzahl Null"
        },
        "summary": {
          "blockingRelationships": "Blockierungsbeziehungen",
          "title": "Übersicht",
          "totalSpots": "Plätze gesamt",
          "withEgressLane": "Mit Ausfahrspur",
          "withoutEgressLane": "Ohne Ausfahrspur"
        },
        "title": "Egress-Berechnung"
      },
      "textEdit": {
        "cancel": "Abbrechen",
        "color": "Farbe",
        "ok": "Ok",
        "size": "Größe",
        "text": "Text",
        "title": "Text ändern"
      }
    },
    "rampCalibrationCanvas": {
      "referenceDistanceDialog": {
        "description": "Beschreibung",
        "distanceLabel": "Entfernungslabel",
        "title": "Referenzentfernungs-Dialog"
      }
    },
    "setupWizard": {
      "complete": "Setup complete!",
      "calibrate": {
        "clickToPlace": "Click on the image to place calibration point {{label}}",
        "enterGPS": "Enter GPS coordinates for this point",
        "ready": "Ready to calibrate"
      },
      "confirm": {
        "finish": "Finish Setup"
      },
      "gps": {
        "title": "GPS Coordinates",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "latError": "Latitude must be between -90 and 90",
        "lngError": "Longitude must be between -180 and 180",
        "emptyError": "Please enter coordinates"
      },
      "review": {
        "continue": "Continue"
      }
    }
  },
  "revenueEstimator": {
    "tabs": {
      "rates": "Tarife",
      "feeCalculator": "Gebührenrechner"
    },
    "migration": {
      "message": "Der Gebührenrechner ist jetzt über die Seitennavigation erreichbar. Klicke unten, um zum Gebührenrechner zu gelangen.",
      "button": "Zum Gebührenrechner"
    },
    "rateCalculator": {
      "title": "Hilf mir, meine aktuellen Tarife zu berechnen",
      "subtitle": "Wenn du deine typischen monatlichen Mieter- oder Nacht-Transient-Gebühren nicht kennst, nutze diesen Rechner, um sie zu ermitteln. Gib einfach ein Beispiel-Luftfahrzeug und die Gesamtgebühr ein, die du aktuell berechnest, um zu sehen, was das in Monats- oder Tagesraten entspricht.",
      "headers": {
        "aircraft": "Flugzeug",
        "dimensions": "Länge x Spannweite",
        "totalArea": "Gesamtfläche",
        "totalFee": "Gesamtgebühr",
        "pricePerArea": "$/{{unit}}"
      },
      "labels": {
        "makeModel": "Typ/Modell",
        "rate": "Rate"
      },
      "formats": {
        "dimensions": "{{length}}L x {{wingspan}}SW",
        "area": "{{area}} {{unit}}"
      }
    },
    "feeCalculator": {
      "headers": {
        "aircraft": "Flugzeug",
        "dimensions": "Länge x Spannweite",
        "buffer": "Puffer",
        "totalArea": "Gesamtfläche",
        "rate": "Rate",
        "cam": "CAM",
        "total": "Gesamt",
        "totalWithCam": "Gesamt + CAM"
      },
      "tooltips": {
        "buffer": "Ein Puffer wird an jedem Ende der Maße hinzugefügt. Beispiel: Ein 2-Fuß-Puffer fügt insgesamt 4 Fuß zur Länge und 4 Fuß zur Spannweite hinzu.",
        "rate": "Gib deine gewünschten Raten unten ein. Du kannst die Standardraten auch unter Einstellungen → Schätzung → Raten ändern.",
        "cam": "Nebenkosten für Gemeinschaftsflächen zur monatlichen Mietergebühr hinzugefügt"
      },
      "labels": {
        "makeModel": "Typ/Modell",
        "buffer": "Puffer",
        "monthlyRate": "$ / {{unit}} / Monat",
        "dailyRate": "$ / {{unit}} / Tag",
        "tenantMonthly": "Mieter (monatlich)",
        "transientDaily": "Durchreisend (täglich)"
      },
      "formats": {
        "totalArea": "{{area}} {{unit}}",
        "dimensions": "{{length}}L x {{wingspan}}WS",
        "camUnit": "$/{{unit}}²"
      }
    },
    "common": {
      "empty": "---"
    },
    "annualTenantTable": {
      "labels": {
        "annualIncrease": "Jährliche Erhöhung in %",
        "aircraftFee": "Flugzeuggebühr",
        "camFees": "CAM-Gebühren",
        "totalFee": "Gesamtgebühr",
        "year": "Jahr {{number}}"
      }
    },
    "ratesForm": {
      "labels": {
        "label": "Label",
        "baseTenantRate": "Basis-Mietpreis",
        "transientRate": "Durchgangsrate",
        "defaultLabel": "Standard",
        "newRate": "Neuer Tarif",
        "defaultBuffer": "Standardpuffer",
        "buffer": "Puffer",
        "defaultCAM": "Standard-Nebenkosten für Gemeinschaftsflächen",
        "or": "od."
      },
      "buttons": {
        "addRate": "Hinzufügen"
      },
      "tooltips": {
        "buffer": "Ein Puffer wird an jedem Ende der Maße hinzugefügt. Beispiel: Ein {{value}}{{unit}}-Puffer fügt insgesamt {{total}}{{unit}} zur Länge und {{total}}{{unit}} zur Spannweite hinzu.",
        "cam": "Nebenkosten werden zur monatlichen Mieterrate hinzugefügt. Du kannst eine prozentuale Gebühr oder eine {{unit}}²-Gebühr angeben."
      }
    }
  },
  "towingEquipment": {
    "headers": {
      "name": "Name",
      "length": "Länge ({{unit}})",
      "width": "Breite ({{unit}})",
      "height": "Höhe ({{unit}})",
      "towBarLength": "Schleppstangenlänge ({{unit}})"
    },
    "buttons": {
      "add": "Neu",
      "remove": "Entfernen",
      "makeDefault": "Standard setzen"
    },
    "labels": {
      "default": "Standard",
      "notAvailable": "k.A."
    }
  },
  "customizeHeatmap": {
    "title": "Heatmap",
    "sections": {
      "refPoints": "Referenzpunkte",
      "preview": "Referenzpunkte-Vorschau"
    },
    "labels": {
      "refPointX": "Ref.-Punkt X",
      "refPointY": "Ref.-Punkt Y",
      "dimensions": "{{value}} ft"
    },
    "buttons": {
      "add": "Neu",
      "preview": "Vorschau"
    }
  },
  "uberAdmin": {
    "executionMatrix": {
      "components": {
        "aircraft": "Flugzeug",
        "obstacles": "Hindernisse",
        "towingEquip": "Schleppausrüstung"
      },
      "headers": {
        "component": "Komponente",
        "prod": "Prod",
        "worker1": "Worker1",
        "worker2": "Worker2"
      },
      "legend": {
        "error": "Fehler",
        "na": "Na",
        "skipped": "Übersprung",
        "success": "Erfolg"
      },
      "noDetails": "Keine Details",
      "title": "Ausführungsmatrix"
    }
  }
}
